var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTrucks = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Shipment-Truck--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Shipment Truck Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 1.5H0.5A0.5 0.5 0 0 0 0 2v11.5a0.5 0.5 0 0 0 0.5 0.5h11a0.5 0.5 0 0 0 0.5 -0.5V2.69a1.36 1.36 0 0 0 -1.5 -1.19ZM9 5v5.5a0.75 0.75 0 0 1 -1.5 0V5A0.75 0.75 0 0 1 9 5ZM4.5 5v5.5a0.75 0.75 0 0 1 -1.5 0V5a0.75 0.75 0 0 1 1.5 0Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.22 4.16a0.25 0.25 0 0 1 -0.15 -0.1L19.33 3C18 1 14.64 1 14.5 1a1 1 0 0 0 -1 1v13a0.52 0.52 0 0 1 -0.52 0.52H0.5A0.5 0.5 0 0 0 0 16v2.27a0.24 0.24 0 0 0 0.13 0.22 0.24 0.24 0 0 0 0.26 0A2.93 2.93 0 0 1 2 18a3 3 0 0 1 2.91 2.31 0.26 0.26 0 0 0 0.24 0.19h0.7a0.26 0.26 0 0 0 0.24 -0.19A3 3 0 0 1 9 18a3 3 0 0 1 2.54 1.43c0.06 0.09 0.11 0.1 0.28 0.1H13a0.47 0.47 0 0 1 0.46 0.46 1 1 0 0 0 1 1h0.26a0.25 0.25 0 0 0 0.25 -0.23 3 3 0 0 1 6 0 0.25 0.25 0 0 0 0.25 0.23H22a2 2 0 0 0 2 -2V9a5 5 0 0 0 -3.78 -4.84Zm2 7.57A0.24 0.24 0 0 1 22 12l-2.75 0a0.25 0.25 0 0 1 -0.25 -0.3V6.26a0.23 0.23 0 0 1 0.08 -0.18 0.26 0.26 0 0 1 0.19 -0.08 3.24 3.24 0 0 1 3 3Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 21a2 2 0 1 0 4 0 2 2 0 1 0 -4 0",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 21a2 2 0 1 0 4 0 2 2 0 1 0 -4 0",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 21a2 2 0 1 0 4 0 2 2 0 1 0 -4 0",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTrucks);
export default ForwardRef;